import "./scan-status.css";

/** A determinate progress bar for an upload in flight. `fraction` is 0..1. */
export function UploadProgress({ fileName, fraction }: { fileName: string; fraction: number }) {
  const percent = Math.round(Math.min(1, Math.max(0, fraction)) * 100);
  return (
    <div className="upload-progress">
      <span className="upload-progress__label" title={fileName}>
        {percent >= 100 ? `Processing ${fileName}…` : `Uploading ${fileName} · ${percent}%`}
      </span>
      <div
        className="upload-progress__bar"
        role="progressbar"
        aria-label={`Uploading ${fileName}`}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={percent}
      >
        <div className="upload-progress__fill" style={{ width: `${percent}%` }} />
      </div>
    </div>
  );
}
